import { DataConfig } from '@/utils/hooks/useDefaultDataConfig';
import { Skeleton } from 'alurkerja-ui';
import { MainTableColumn } from './MainTable';

interface TableTeamProps {
  pageConfig: DataConfig;
  columns: MainTableColumn[];
  showActions?: boolean;
}

export default function TableLoadingState({ pageConfig, columns, showActions }: Readonly<TableTeamProps>) {
  return Array.from({ length: pageConfig.limit }, (_, rowIndex) => (
    <tr key={`skeleton-${rowIndex}`} className="bg-white border-b">
      <td className="px-3 py-2 text-center">
        <Skeleton className="h-7" />
      </td>
      {columns.map((column, indexCol) => (
        <td key={`skeleton-${rowIndex}-${column.name}-${indexCol}`} className={`px-3 py-2 ${column.className || ''}`}>
          <Skeleton className="h-7" />
        </td>
      ))}
      {showActions && (
        <td className="px-3 py-2">
          <Skeleton className="h-7" />
        </td>
      )}
    </tr>
  ));
}
